<div class="edit-modal kw-dialog">

  <div class="modal-header">
    <div>
      <h2 class="modal-title">{{"Lot" | tenantWords}} Actions</h2>
      <div class="modal-subtitle" *ngIf="this.data?.lotNumber">{{"Lot" | tenantWords}} {{this.data.lotNumber}}</div>
    </div>
    <button mat-icon-button class="close-btn" type="button" aria-label="Close" (click)="close()">
      <fa-icon [icon]="faXmark"></fa-icon>
    </button>
  </div>

  <div class="modal-body">
    <div class="option-list">
      <button type="button" class="option-card" (click)="close('move')">
        <span class="option-icon"><fa-icon [icon]="faTruck"></fa-icon></span>
        <span class="option-text">
          <span class="option-name">Move {{"Inventory" | tenantWords}}</span>
          <span class="option-sub">Transfer this {{"lot" | tenantWords}} to another location</span>
        </span>
        <fa-icon [icon]="faChevronRight" class="option-chevron"></fa-icon>
      </button>

      <button type="button" class="option-card" (click)="close('adjust')">
        <span class="option-icon"><fa-icon [icon]="faSliders"></fa-icon></span>
        <span class="option-text">
          <span class="option-name">Adjust Quantity</span>
          <span class="option-sub">Add or remove quantity on this {{"lot" | tenantWords}}</span>
        </span>
        <fa-icon [icon]="faChevronRight" class="option-chevron"></fa-icon>
      </button>
    </div>
  </div>

  <div class="modal-footer">
    <button mat-stroked-button type="button" (click)="close()">Cancel</button>
  </div>

</div>
